export default __webpack_public_path__ + "static/Shun-95cbcfc53926df27171182675ea119c2.jpeg";